import config from '../../config';

export default {
  url: `${config.api.baseURL}/videos`,
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/videos/list.js